/**
 * Shame component.
 * A script dedicated to housing your nasty, hacky, quick-fix JS.
 * Source: https://csswizardry.com/2013/04/shame-css/
 *
 * Usage:
 * Call Shame.init() to initialize the functionalities.
 *
 * Methods:
 *
 * init(): initialize script
 */

const Modal = require('./components/modal.js');

const shame = () => {
	// **************
	// PART SEARCH ONLOAD FNS
	// **************

	//show thank you message after submit
	if (document.querySelector('.umbraco-forms-submitmessage')) {
		const $modal = document.querySelector('.umbraco-forms-submitmessage').closest('.modal');
		const modalId = $modal.getAttribute('id');
		Modal.openModal(modalId);
	}
	if (document.querySelector('.umbraco-forms-submitmessage-html')) {
		const $modal = document.querySelector('.umbraco-forms-submitmessage-html').closest('.modal');
		const modalId = $modal.getAttribute('id');
		Modal.openModal(modalId);
	}
};

module.exports = {
	init: shame
};
